import styled from 'styled-components';

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${({ isCentralized }) => (isCentralized ? 'center' : '')};
  align-items: ${({ isCentralized }) => (isCentralized ? 'center' : '')};
  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export default Row;
